import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import ContractProcessDetailSection from "../sections/ContractProcessDetailSection";

interface Props {
  id: string;
}

const ContractProcessDetail = (props: Props) => {
    
  const { t } = useTranslation("shared\\moduleNames");

  const { id } = useParams<Props>();

  return (
    <>
      <Header
        title={t("contractProcess.detailTitle")}
        includeBreadcrumbs
        links={[{ text: t("contractProcess.title"), to: "/contractProcess" }]}
      />
      <ModuleContent>
        <ContractProcessDetailSection contractId={id} />
      </ModuleContent>
    </>
  );
};

export default ContractProcessDetail;
